/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const commercialSchema = z.object({
      "id": z.string().describe("Identifiant du commercial"),
  "nom": z.string().describe("Nom de famille du commercial"),
  "prenom": z.string().describe("Prénom du commercial"),
  "telephone": z.string().describe("Numéro de téléphone du commercial"),
  "urlPhoto": z.string().describe("URL de la photo du commercial"),
  "urlPriseDeRendezVous": z.string().describe("Lien pour prendre rendez-vous avec le commercial"),
  "initiales": z.string().describe("Initiales du commercial (générées à partir du prénom et du nom)").optional()
      })